import React, { useEffect, useState } from "react";
import "./topbar.css";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import AdminProfileModal from "./AdminProfileModal";

export default function Topbar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [name, setName] = useState("");
  const Name = JSON.parse(localStorage.getItem("data"));
  const [openBox, setOpenBox] = useState(false);
  const [log, setLog] = useState(true);
  const [isImage, setIsImage] = useState(true);
  useEffect(() => {
    if (!Name) {
      setName("");
    }
    if (Name) {
      setName(Name);
    }
    const auth_token = localStorage.getItem("auth_token");
    const data = localStorage.getItem("data");

    if (!auth_token && !data) {
      setLog(false);

      sessionStorage.setItem("key", 0);
    }
  }, [log]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlelogout = () => {
    localStorage.clear();
    sessionStorage.clear()
    setLog(false);
    window.location.href = "/";
  };

  const handletoast = () => {
    toast.info("Exciting updates are coming soon!", { position: "top-center" });
  };

  useEffect(() => {
    if (Name?.photo) {
      setIsImage(false);
    } else {
      setIsImage(true);
    }
  }, []);

  return (
    <div className="topbar">
      <div className="topbar">
        <button onClick={handletoast}>
          <NotificationsNoneOutlinedIcon />
        </button>
        <button onClick={handletoast}>
          <EmailOutlinedIcon />
        </button>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className="username"
        >
          <div>
            {isImage ? (
              <PeopleOutlineIcon
                style={{
                  color: "black",
                  background: "rgba(28, 28, 28, 0.11)",
                  padding: "4px",
                  borderRadius: "6px",
                }}
              />
            ) : (
              <img
                src={Name?.photo || ""}
                alt="Avtar"
                style={{
                  color: "black",
                  background: "rgba(28, 28, 28, 0.11)",
                  borderRadius: "10px",
                  width: "30px",
                  height: "30px",
                  border: "1px solid #1c1c1c",
                }}
              />
            )}
          </div>
          <div className="name">
            <h6>{name?.name || "ADMIN"}</h6>
            <KeyboardArrowDownOutlinedIcon />
          </div>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            style={{
              width: "200px",
              display: "flex",
              justifyContent: "flex-end",
              borderBottom: "1px solid #1c1c1c6c",
            }}
            onClick={() => {
              handleClose();
              setOpenBox(true);
            }}
          >
            Profile
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            disabled
            style={{
              width: "200px",
              display: "none",
              justifyContent: "flex-end",
            }}
          >
            My account
          </MenuItem>
          <MenuItem
            style={{
              width: "200px",
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => {
              handleClose();
              handlelogout();
            }}
          >
            Logout
          </MenuItem>
        </Menu>
      </div>
      <AdminProfileModal openBox={openBox} setOpenBox={setOpenBox} />
      {!log && (
        <div
          className="logout-loader"
          style={{ background: "rgba(28, 28, 28, 0.43)" }}
        >
          {" "}
          <CircularProgress
            style={{ color: "#FFFF", fontSize: "10rem" }}
          />{" "}
        </div>
      )}
    </div>
  );
}
